<template>
  <div
    class="dynamic-panel-wrap"
    :class="`${element.isLock ? 'wrap' : 'wrap cursor'} ${
      element.compData.type
    }-theme-${element.compData.styleId}`"
    ref="dom"
    :style="{
      ...getStyles({
        wrapHeight: element.boxStyle.height,
      }),
      background: element.children.find(val => val.active == true).color
    }"
  >
    <div v-for="(it, index) in element.children" :key="index">
      <Page
        :id="it.id"
        v-show="it.active"
        :elements="it.children"
        :isDynamicPanel="isDynamicPanel"
      ></Page>
    </div>
  </div>
</template>

<script>
import Page from "./Page";

export default {
  name: "editor-dynamic-panes",
  props: {
    element: {
      type: Object,
      require: true,
    },
    canvasWidth: {
      default: 500
    },
    canvasHeight: {
      default: 500
    }
  },
  data() {
    return {
      // loading: true
      timer: null,
      fontStyleTableName: null,
      fontStyleTableUrl: null,
      isDynamicPanel: true,
      index: -1
    };
  },
  computed: {
    boxStyle() {
      return this.element.boxStyle
    },
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  methods: {
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100,
      });
    },
    start() {
      this.timer = setInterval(() => this.init(), 2000)
    },
    init() {
      const _this = this
      let len = (this.element.children || []).length - 1
      this.index = this.index == len ? 0 : this.index + 1;
      (this.element.children || []).forEach((it, ins) => {
        if (this.index == ins) {
          it.active = true
          this.$blueMap.animateShow(false, {
            id: this.element.id
          }, {
            easing: 'easing_in_out',
            duration: 1500,
            animation: "slide-right"
          }, () => {
          });
        } else {
          it.active = false
        }
      })
    }
  },
  mounted() {
    // console.log(this.plugin, 999999)
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
      }
    })
    if (!!this.element.isSwiper) {
      this.init()
      this.start()
    }
    // this.init()
  },
  watch: {
    "element.stopSwiper"(val) {
      this.timer && clearInterval(this.timer)
    },
    "element.startSwiper"(val) {
      // this.timer && this.start()
    }
  },
  components: {
    Page
  },
};
</script>

<style lang='less' scoped>
.dynamic-panel-wrap {
  height: var(--wrapHeight);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 6px; //竖轴宽度
    height: 6px; //横轴宽度
    background: #FFFFFF03;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    display: none;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #7C7D7D;
  }

}
</style>
